var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9538 11.3609C11.4364 11.3609 11.8277 10.9696 11.8277 10.487C11.8277 10.0043 11.4364 9.61304 10.9538 9.61304C10.4711 9.61304 10.0798 10.0043 10.0798 10.487C10.0798 10.9696 10.4711 11.3609 10.9538 11.3609Z",
    stroke: "#1F3048",
    strokeWidth: 2.09743,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0714 11.3609C17.5541 11.3609 17.9454 10.9696 17.9454 10.487C17.9454 10.0043 17.5541 9.61304 17.0714 9.61304C16.5888 9.61304 16.1975 10.0043 16.1975 10.487C16.1975 10.9696 16.5888 11.3609 17.0714 11.3609Z",
    stroke: "#1F3048",
    strokeWidth: 2.09743,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83682 11.3609C5.31948 11.3609 5.71075 10.9696 5.71075 10.487C5.71075 10.0043 5.31948 9.61304 4.83682 9.61304C4.35416 9.61304 3.96289 10.0043 3.96289 10.487C3.96289 10.9696 4.35416 11.3609 4.83682 11.3609Z",
    stroke: "#1F3048",
    strokeWidth: 2.09743,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsIcon);
export default __webpack_public_path__ + "static/media/DotsIcon.12b02826e995c6646710746b22e18131.svg";
export { ForwardRef as ReactComponent };